import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify';
import { fetchClaimViewDetails, fetchClaimViewDetailsDoc } from '../../utilities/api';
import moment from 'moment';


export const fetchClaimDetails = createAsyncThunk(
    'ClaimData', fetchClaimViewDetails
)
export const fetchClaimDetailsDoc = createAsyncThunk(
    'ClaimDataDoc', fetchClaimViewDetailsDoc
)

const initialState = {
    isDataFetched: false,
    program: '',
    applicationId: '',
    status: '',
    patientname: '',
    claimId: '',
    claimInfo: [],
    checkNumber: '',
    datePaid: '',
    DenyReasonsList: [],
    DenialReason: '',
    TotalAmountSubmitted: '',
    TotalPaidAmount: '',
    Stage: "",
    payabletTo: {
        payabletTo: '--',
        address: '--',
        city: '--',
        state: "--",
        zipcode: "--",
        paymentType: '--'
    },
    attachments: []


}

const claimDetailSlice = createSlice({
    name: 'ClaimDetails',
    initialState,

    reducers: {
        resetClaimDataFetched: (state, action) => {
            state.isDataFetched = false
        },
        resetClaimDetails: (state) => {
            state.isDataFetched = false
            state.program = ''
            state.applicationId = ''
            state.status = ''
            state.patientname = ''
            state.claimId = ''
            state.claimInfo = []
            state.checkNumber = ''
            state.Stage = ''
            state.datePaid = ''
            state.DenyReasonsList = []
            state.DenialReason = ''
            state.TotalAmountSubmitted = ''
            state.TotalPaidAmount = ''
            state.payabletTo = {
                payabletTo: '--',
                address: '--',
                city: '--',
                state: "--",
                zipcode: "--",
                paymentType: '--'
            }
            state.attachments = []
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchClaimDetails.pending, (state, action) => {
                state.loader = true
            })
            .addCase(fetchClaimDetails.fulfilled, (state, action) => {
                state.isDataFetched = true
                let response = action.payload.res;
                state.program = action.payload.program;
                state.applicationId = response?.ApplicationID || '--'
                state.patientname = response?.PatientInformation?.FullName || '--'
                state.status = response?.pyStatusWork || '--'
                state.claimId = response?.pyID || '--'

                response?.LineItems.length > 0 && response?.LineItems.map((data) => {
                    state.claimInfo.push({
                        Provider: data?.Provider,
                        AmountSubmitted: data?.AmountSubmitted || '--',
                        DOSFromDate: moment(data?.DOSFromDate).format('MM/DD/YYYY') || '--',
                        DOSToDate: moment(data?.DOSToDate).format('MM/DD/YYYY') || '--',
                        ReasonCode: data.ReasonCode,
                        Disposition: data.Disposition,
                        IsAIParsed: data?.IsAIParsed == "true" ? true : false
                    })
                })
                state.checkNumber = response?.CheckNumber || '--'
                state.datePaid = typeof response?.CheckDate != 'undefined' ? moment(response?.CheckDate).format('MM/DD/YYYY') : '--'
                state.DenyReasonsList = response?.DenyReasonsList || response.DenialReasonsList 
                state.DenialReason = response?.DenialReason || response?.DenyReasonsList || response.DenialReasonsList || '--'
                state.payabletTo.payabletTo = response?.RemitTo?.PayableTo || '--'
                state.payabletTo.address = response?.RemitTo?.AddressInfo?.FullAddressLine || '--'
                state.payabletTo.state = response?.RemitTo?.AddressInfo?.State || '--'
                state.payabletTo.city = response?.RemitTo?.AddressInfo?.City || '--'
                state.payabletTo.zipcode = response?.RemitTo?.AddressInfo?.ZipCode || '--'
                state.payabletTo.paymentType = response?.PatientInformation?.PaymentType || '--'
                state.TotalAmountSubmitted = response?.TotalAmountSubmitted || '--'
                state.TotalPaidAmount = response?.TotalPaidAmount || '--'
                state.Stage = response?.Stage || '--'
            })
            .addCase(fetchClaimDetails.rejected, (state, action) => {

            })



            .addCase(fetchClaimDetailsDoc.pending, (state, action) => {
                state.loader = true
            })
            .addCase(fetchClaimDetailsDoc.fulfilled, (state, action) => {
                let response = action.payload.res;
                state.attachments = response?.pxResults

            })
            .addCase(fetchClaimDetailsDoc.rejected, (state, action) => {

            })
    },
})

export const { resetClaimDetails, resetClaimDataFetched } = claimDetailSlice.actions

export default claimDetailSlice.reducer
